import { action, computed, observable } from 'mobx';
import { CSSProperties } from 'react';

export interface IToastItem {
  key: string;
  text: string | JSX.Element;
  timeout: number;
  timer?: number;
  style?: CSSProperties;
}

export class ToastStore {
  // @observable items = new Map() 하면 옵저빙이 안됨 — 대체 무엇 — MobX 4라서 그런가
  readonly items: Map<string, IToastItem> = observable.map(undefined, { deep: false });

  @computed
  get Size(): number {
    return this.items.size;
  }

  @action
  addItem(item: IToastItem): void {
    if (this.items.has(item.key)) {
      return;
    }

    this.items.set(item.key, item);
  }

  @action.bound
  clearItem(item: IToastItem): void {
    this.items.delete(item.key);
    item.timer !== undefined && clearTimeout(item.timer);
  }
}
